import React, { useState, useRef, useEffect } from "react";
import closeImg from "../Resources/svg/icon-close.svg";
import TableVAS from "./tableVAS";
import TableRG from './tableRG';
import Loading from "./loading";
import { getPdfSimulacion } from '../Utils/utils'

const ModalGenerateSimulacion = ({ open, onCloseModalPdf, cleanTablePdf, items, activeBtn, id_product }) => {
  const [linkPdf, setLinkPdf] = useState('');
  const [isLoading, setisLoading] = useState(false);
  const elem = useRef(null);
  const onHandlerPdf = async () => {

    const rowData = items.filter(item => item.active);
    if (rowData.length === 0) {
      alert('Debe seleccionar al menos una cotización')
    } else {
      setisLoading(true);
      try {
        let type = id_product === 0 ? 'AS' : 'RG'
        const response = await getPdfSimulacion(type, rowData)
        if (response.status) {
          setLinkPdf(response.data);
        } else {
          console.log(response.message)
        }
        setisLoading(false);
      } catch (error) {
        setisLoading(false);
      }
    }
  };
  useEffect(() => {
    if (linkPdf) elem.current.click();
  }, [linkPdf])

  return (
    <div className={`md-g-wapper  ${open ? "md-g-open" : ""}`}>
      <div className="md-g-wapper__container">
        <img
          src={closeImg}
          alt="imgClose"
          className="md-g-wapper__container__button-close"
          onClick={() => onCloseModalPdf()}
        />
        
        {
          id_product === 0 ? <TableVAS items={items} /> : <TableRG items={items} />
        }

        <div className="table__btns">
          <a style={{ display: 'none' }}
            target="_blank"
            rel="noopener noreferrer"
            href={linkPdf}
            ref={elem}
          />
          <button
            className="btnew is-secondary is-medium"
            onClick={() => cleanTablePdf()}
            disabled={items.length === 0 ? true : false}
          >
            Limpiar Tabla
          </button>
          <button
            className="btnew is-medium"
            onClick={onHandlerPdf}
            disabled={items.length === 0 || !activeBtn ? true : false}
          >
            DESCARGAR PDF
          </button>
        </div>
      </div>
      {isLoading && <Loading  />}
    </div>
  );
};
export default ModalGenerateSimulacion;
